// extracted by mini-css-extract-plugin
module.exports = {"vBorderWidth":"1px","vActionListItemHeight":"32px","wrapper-ctn":"ActionListWrapper__wrapper-ctn___IXeUN"};